"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var React = require("react");
var buttons_1 = require("../buttons");
var App_1 = require("../../App");
var filters_1 = require("./filters");
var orderingList_1 = require("./orderingList");
var settings_1 = require("./settings");
var userdefined_1 = require("../../interfaces/userdefined");
var queryStringParser_1 = require("./queryStringParser");
var userDefinedField_1 = require("../userDefinedField");
var config_1 = require("../../config");
var generic_1 = require("../generic");
var savedViews_1 = require("../savedViews");
var riskbimContext_1 = require("../../context/RiskBim/riskbimContext");
var ControlListToolbar = (function (_super) {
    __extends(ControlListToolbar, _super);
    function ControlListToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.savedViewsRef = React.createRef();
        _this.onOrder = function () {
            App_1.store.controllist.fetchData(window.location.search);
        };
        _this.onSaveSettings = function (values) {
            App_1.store.controllist.settings.update(values).then(function () {
                var _a;
                App_1.store.controllist.fetchData(window.location.search);
                (_a = _this.savedViewsRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
            });
        };
        _this.countFilters = function () {
            return _this.state.qs.get_key_count_for(['q', 'id_status', 'id_owner', 't', 'confidential', 'eval', 'cq',
                'id_c_status', 'id_c_owner', 'id_c_tags', 'unattached_controls',
                'reviewed_by', 'reviewed_before', "reviewed_after"
            ]) + _this.state.qs.get_udf_key_count();
        };
        _this.applyHandler = function (event) {
            var paramsString = _this.state.qs.toString();
            window.history.pushState(null, null, window.location.pathname + "?" + paramsString);
            App_1.store.controllist.fetchData("?" + paramsString);
            jQuery('#controlFilterCollapsible').removeClass('show');
        };
        _this.changeHandler = function (name, value) {
            var newState = {};
            if ((0, userdefined_1.isFieldType)(name)) {
                value = value.map(function (udf_value) {
                    if (udf_value.field_type.type_id == userDefinedField_1.UDFTypeChoices.DATE &&
                        !udf_value.field_type.options && udf_value.value != null)
                        udf_value.value = udf_value.value.format(config_1.ISO_DATE_FORMAT);
                    return udf_value;
                });
                var udf_type_1 = name;
                newState["udf_values"] = (_this.state.udf_values
                    .filter(function (udf_value) { return udf_value.field_type.id != udf_type_1.id; })
                    .concat(value));
            }
            else
                newState[name] = value;
            var new_qs = _this.state.qs.clone();
            new_qs.reset_from_state(__assign(__assign({}, _this.state), newState));
            newState['qs'] = new_qs;
            _this.setState(newState);
        };
        _this.handleKeypress = function (e) {
            console.log(e.key);
            if (e.key === 'Enter') {
                $('#apply_button').click();
            }
        };
        _this.onApplyView = function (view) {
            var sep = view.queryString.includes("?") ? "&" : "?";
            var qs = view.queryString + sep + "savedview=" + view.id;
            window.history.pushState(null, null, window.location.pathname + qs);
            App_1.store.controllist.settings.fetchData(qs);
            App_1.store.controllist.fetchData(qs);
        };
        var qs = new queryStringParser_1.QueryStringParser(window.location.search);
        _this.state = {
            qs: qs,
            q: qs.get("q") || "",
            id_status: qs.getAll("id_status"),
            id_owner: qs.getAll("id_owner"),
            t: qs.getAll("t"),
            confidential: qs.getAll("confidential"),
            eval: qs.getAll("eval"),
            reviewed_by: qs.getAll("reviewed_by"),
            reviewed_after: qs.get("reviewed_after"),
            reviewed_before: qs.get("reviewed_before"),
            cq: qs.get("cq") || "",
            id_c_status: qs.getAll("id_c_status"),
            id_c_owner: qs.getAll("id_c_owner"),
            id_c_tags: qs.getAll("id_c_tags"),
            id_c_costs: qs.getAll("id_c_costs"),
            unattached_controls: !!qs.get("unattached_controls"),
            aq: qs.get("aq") || "",
            id_ac_status: qs.getAll("id_ac_status"),
            id_ac_owner: qs.getAll("id_ac_owner"),
            id_ac_tags: qs.getAll("id_ac_tags"),
            udf_values: qs.get_udf_fields(),
        };
        return _this;
    }
    ControlListToolbar.prototype.render = function () {
        var _this = this;
        var context = App_1.store.context.get();
        var filter_counter = this.countFilters();
        return (React.createElement("div", { id: "listAccordion" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    get_term("Number of controls in current filtering"),
                    ": ",
                    this.props.rows_counter)),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "btn-toolbar mb-3", role: "toolbar", "aria-label": "Toolbar with button groups" },
                        React.createElement("div", { className: "col-8" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "input-group", style: { paddingRight: 10.5 } },
                                    React.createElement("input", { name: "q", type: "text", defaultValue: this.state.qs.get('q'), className: "form-control", placeholder: get_term("Search Risk"), onChange: function (e) { return _this.changeHandler(e.currentTarget.name, e.currentTarget.value); }, onKeyPress: this.handleKeypress }),
                                    React.createElement("div", { className: "input-group-append" },
                                        React.createElement("button", { className: "btn btn-primary btn-block", id: "apply_button", type: "button", onClick: this.applyHandler },
                                            React.createElement("span", { className: "fa fa-search" })))),
                                React.createElement("div", { className: "input-group" },
                                    React.createElement("input", { name: "cq", type: "text", defaultValue: this.state.qs.get('cq'), className: "form-control", placeholder: get_term("Search Control"), onChange: function (e) { return _this.changeHandler(e.currentTarget.name, e.currentTarget.value); }, onKeyPress: this.handleKeypress }),
                                    React.createElement("div", { className: "input-group-append" },
                                        React.createElement("button", { className: "btn btn-primary btn-block", id: "apply_button", type: "button", onClick: this.applyHandler },
                                            React.createElement("span", { className: "fa fa-search" })))),
                                React.createElement("div", { className: "btn-group", id: "filters_group", role: "group", "aria-label": "Filter, List Settings and Ordering group" },
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "filter", "data-toggle": "collapse", "data-target": "#controlFilterCollapsible", "aria-expanded": "false", "aria-controls": "controlFilterCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                                        " ",
                                        gettext("Filters"),
                                        " ",
                                        filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, filter_counter))),
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "setting", "data-toggle": "collapse", "data-target": "#controlSettingsCollapsible", "aria-expanded": "false", "aria-controls": "controlSettingsCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.cog }),
                                        " ",
                                        gettext("List settings")),
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "ordering", "data-toggle": "collapse", "data-target": "#controlOrderingCollapsible", "aria-expanded": "false", "aria-controls": "controlOrderingCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.sorting }),
                                        " ",
                                        gettext("Ordering"))))),
                        React.createElement("div", { className: "col-4" },
                            React.createElement("div", { className: "row justify-content-end" },
                                React.createElement("div", { className: "btn-group d-none d-lg-inline-flex", id: "list_actions_group", role: "group", "aria-label": "Actions group" },
                                    React.createElement(buttons_1.ActionButton, { onClick: function (event) { return App_1.store.controlDialog.openDialog(); } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                                        " ",
                                        gettext("New Control")),
                                    React.createElement(buttons_1.ActionButton, { onClick: function (event) { $('#EditableList__BulkButtonId').click(); } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                                        " ",
                                        get_term("Edit controls")),
                                    this.props.has_business_model &&
                                        React.createElement(buttons_1.ActionButton, { onClick: function (event) { return _this.props.clickExportHandler.bind(_this)(); }, style: buttons_1.ButtonStyles.ACTION },
                                            React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                                            " ",
                                            gettext("Export")),
                                    this.props.has_bim2d &&
                                        React.createElement(buttons_1.ActionButton, { onClick: this.context.openDialog, style: buttons_1.ButtonStyles.ACTION },
                                            React.createElement(generic_1.Icon, { name: generic_1.Icons.map_with_locations }),
                                            " ",
                                            gettext("Control Locations"))),
                                React.createElement("div", { className: "btn-group d-lg-none", role: "group" },
                                    React.createElement(buttons_1.ActionButton, { className: "dropdown-item", onClick: function (event) {
                                            $('#EditableList__BulkButtonId').click();
                                        } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                                        " ",
                                        get_term("Edit controls")),
                                    React.createElement("button", { type: "button", className: "btn btn-link dropdown-toggle dropdown-toggle-split", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                                        React.createElement("span", { className: "sr-only" }, "Toggle Dropdown")),
                                    React.createElement("div", { className: "dropdown-menu" }, this.props.has_business_model &&
                                        React.createElement(buttons_1.ActionButton, { className: "dropdown-item", onClick: function (event) { return _this.props.clickExportHandler.bind(_this)(); }, style: buttons_1.ButtonStyles.ACTION },
                                            React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                                            " ",
                                            gettext("Export")))),
                                React.createElement("div", null,
                                    React.createElement(savedViews_1.SavedViewsDropdown, { ref: this.savedViewsRef, projectId: String(context.project), listType: "control", onApplyView: this.onApplyView }))))))),
            React.createElement("div", { className: "row toolbarCollapsible" },
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "controlFilterCollapsible" },
                    React.createElement(filters_1.ControlFilter, { filter: App_1.store.controllist.filter.data, qs: this.state.qs, include_text: false, onChangeHandler: this.changeHandler }),
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("button", { className: "btn btn-primary btn-block", type: "button", onClick: this.applyHandler }, gettext("Apply")))),
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "controlSettingsCollapsible" },
                    React.createElement(settings_1.default, { settings: App_1.store.controllist.settings.data, save: this.onSaveSettings })),
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "controlOrderingCollapsible" },
                    React.createElement(orderingList_1.default, { ordering: App_1.store.controllist.data.ordering, onOrder: this.onOrder })))));
    };
    ControlListToolbar.contextType = riskbimContext_1.default;
    ControlListToolbar = __decorate([
        mobx_react_1.observer
    ], ControlListToolbar);
    return ControlListToolbar;
}(React.Component));
exports.default = ControlListToolbar;
